import React, { useState, useContext } from "react";
import useForceUpdate from 'use-force-update';
import Fade from "react-reveal/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api_handler } from "../../services/api";
import {
  faAt,
  faUserLock,
  faMapMarked,
  faQrcode,
  faUser,
  faKey,
  faAddressCard,
  faFingerprint,
  faUserTag,
  faBuilding,
  faTabletAlt,
  faSpinner,
  faPhone,
  faUserMd,
  faGlobeEurope,
} from "@fortawesome/free-solid-svg-icons";
import Message from "../../components/Common/Messages";
import { GlobalStateContext } from "../../state/GlobalContextProvider";
import {
  tellalidate,
  tellidate_form,
  tell_errors,
} from "../../services/tell_validate";

export const isBrowser = () => typeof window !== "undefined";
const clearLocalStorage = () => {
  if (isBrowser) {
    window.localStorage.clear();
  }
};

const RegisterPage = () => {
  const themeState = useContext(GlobalStateContext);

  const [registerStage, setRegisterStage] = useState(0);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [organisationName, setOrganisationName] = useState(null);
  const [orgWebsite, setOrgWebsite] = useState(null);
  const [orgEmail, setOrgEmail] = useState(null);
  const [orgContactNumber, setOrgContactNumber] = useState(null);
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [authMessageType, setAuthMessageType] = useState("");
  const [authMessageTitle, setAuthMessageTitle] = useState("");
  const [authMessageDesc, setAuthMessageDesc] = useState("");
  const [showError, setShowError] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsAcceptedErr, setTermsAcceptedErr] = useState("");
  const [isLoading, setIsLoading] = useState(0);

  const [inputStore, setInputStore] = useState({});
  const [errorStore, setErrorStore] = useState({});
  const [appList, setAppList] = useState([]);

  /* INPUT HANDLERS */

  const handleFirstName = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastName = (event) => {
    setLastName(event.target.value);
  };

  const handleOrganisationName = (event) => {
    setOrganisationName(event.target.value);
  };

  const handleOrgWebsite = (event) => {
    setOrgWebsite(event.target.value);
  };

  const handleOrgEmail = (event) => {
    setOrgEmail(event.target.value);
  };

  const handleOrgContactNumber = (event) => {
    setOrgContactNumber(event.target.value);
  };

  const handlePassword = (event) => {
    setPassword(event.target.value);
  };

  const handlePasswordConfirm = (event) => {
    setConfirmPassword(event.target.value);
  };

  const inputhandler = (event) => {

    const isValid = tellalidate(
      event.target.name,
      event.target.value,
      telladate_obj
    );

    setInputStore({
      ...inputStore,
      [event.target.name]: event.target.value,
    });
    setErrorStore(tell_errors);
  };

  const checkhandler = (event) => {
    if (event.target.checked === true) {
      setTermsAccepted(true);
      setTermsAcceptedErr('');
    } else {
      setTermsAccepted(false);
      setTermsAcceptedErr("You must accept the terms and conditions to proceed");
    }
  };

  const forceUpdate = useForceUpdate();

  const telladate_obj = {
    organisationName: {
      name: "Organisation Name",
      presence: true,
      length: { min: 1, max: 50, message: "must be a maximum of 8 characters" },
    },
    website: {
      name: "Website",
      presence: true,
      length: {
        min: 1,
        max: 35,
        message: "must be a maximum of 35 characters",
      },
    },
    BuildingName: {
      name: "Building Name / Number ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    StreetName: {
      name: "Street Name ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    Postcode: {
      name: "Postcode ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    Country: {
      name: "Country ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    firstName: {
      name: "First Name ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    lastName: {
      name: "Last Name ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    email: {
      name: "Email ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    phone: {
      name: "Landline / Mobile  ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    password: {
      name: "Password ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
    passwordConfirm: {
      name: "Password Confirmation ",
      presence: true,
      length: {
        min: 1,
        max: 80,
        message: "must be a maximum of 80 characters",
      },
    },
  };

  const register_org = async (e) => {
    
    clearLocalStorage();
    e.preventDefault();
   
    setIsLoading(1);
    if (!termsAccepted) {
      setTermsAcceptedErr(
        "You must accept the terms and conditions to proceed"
      );
      setIsLoading(0);
      return;
    }

    const isValid = tellidate_form(inputStore, telladate_obj);

    setErrorStore(tell_errors);

    

    /* var data = {
      name: organisationName,
      website: orgWebsite,
      email: orgEmail,
      phone: orgContactNumber,
      pword: password,
      pword_confirm: confirmPassword,
      first_name: firstName,
      last_name: lastName,
    };
*/
    if (isValid) {
      var data = {
        company: {
          name: inputStore.organisationName,
          website: inputStore.website,
          address_line1: inputStore.BuildingName,
          address_line2: inputStore.StreetName,
          address_line3: inputStore.TownCity ? inputStore.TownCity : "",
          address_line4: inputStore.County ? inputStore.County : "",
          postcode: inputStore.Postcode,
          country: inputStore.Country,
        },
        user: {
          email: inputStore.email,
          phone: inputStore.phone,
          pword: inputStore.password,
          pword_confirm: inputStore.passwordConfirm,
          first_name: inputStore.firstName,
          last_name: inputStore.lastName,
          position: inputStore.position ? inputStore.position : "",
        },
      };


      const api_rsp = await api_handler("org:create", data, "POST");
      if (api_rsp.code !== 200) {
        setAuthMessageType("error");
        setAuthMessageTitle("Sorry!");
        setAuthMessageDesc(api_rsp.data.error);
        setShowError(1);
        setIsLoading(0);
      } else {
        setRegisterStage(3);
        setIsLoading(0);
      }
    } else {
      setIsLoading(0);
      forceUpdate();
    }
  };



  return (
    <div className={"login-screen-body " + themeState.theme}>
      <section className="section section-body">
        <div className="container-md">
          <div className="container-md  mb-3">
            {registerStage === 0 ? (
              <div id="s1_form">
                {showError === 1 ? (
                  <Message
                    infoType={authMessageType}
                    infoTitle={authMessageTitle}
                    infoDesc={authMessageDesc}
                  />
                ) : null}
                <form onSubmit={register_org}>
                  <h3>Register</h3>
                  <p>
                    Complete the form below to register and create an account
                    with Tell Connect and instantly access our services.
                  </p>
                  <div className="container-md boxc mb-3">
                    <div>
                      <h5>
                        <i className="mr-3 mb-3">
                          <FontAwesomeIcon icon={faBuilding} />
                        </i>
                        Organisation Details
                      </h5>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="organisationName">
                            Organisation Name
                          </label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="organisationName"
                              id="organisationName"
                              placeholder="Organisation Name"
                              value={inputStore.organisationName}
                              onChange={inputhandler}
                            />

                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faBuilding} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.organisationName ? (
                            <div className="inputErr">
                              {errorStore.organisationName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="website">Website</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="website"
                              id="website"
                              placeholder="Organisation Website"
                              value={inputStore.website}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faMapMarked} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.website ? (
                            <div className="inputErr">{errorStore.website}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="BuildingName">Address Line 1 </label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="BuildingName"
                              id="BuildingName"
                              placeholder="Address Line 1 "
                              value={inputStore.BuildingName}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAddressCard} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.BuildingName ? (
                            <div className="inputErr">
                              {errorStore.BuildingName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="StreetName">Address Line 2</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="StreetName"
                              id="StreetName"
                              placeholder="Address Line 2"
                              value={inputStore.StreetName}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAddressCard} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.StreetName ? (
                            <div className="inputErr">
                              {errorStore.StreetName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="TownCity">Address Line 3</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="TownCity"
                              id="TownCity"
                              placeholder="Address Line 3"
                              value={inputStore.TownCity}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAddressCard} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.TownCity ? (
                            <div className="inputErr">
                              {errorStore.TownCity}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="County">Address Line 4</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="County"
                              id="County"
                              placeholder="Address Line 4"
                              value={inputStore.County}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAddressCard} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.County ? (
                            <div className="inputErr">{errorStore.County}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="Postcode">Postcode</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="Postcode"
                              id="Postcode"
                              placeholder="Postcode"
                              value={inputStore.Postcode}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAddressCard} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.Postcode ? (
                            <div className="inputErr">
                              {errorStore.Postcode}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="Country">Country</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="Country"
                              id="Country"
                              placeholder="Country"
                              value={inputStore.Country}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faGlobeEurope} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.Country ? (
                            <div className="inputErr">{errorStore.Country}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                  <div className="container-md boxc mb-3">
                    <h5>
                      <i className="mr-3 mb-3">
                        <FontAwesomeIcon icon={faUser} />
                      </i>
                      Primary User Details
                    </h5>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="firstName">First Name</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="firstName"
                              id="firstName"
                              placeholder="First Name"
                              value={inputStore.firstName}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faUserTag} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.firstName ? (
                            <div className="inputErr">
                              {errorStore.firstName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="lastName">Last Name</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="lastName"
                              id="lastName"
                              placeholder="Last Name"
                              value={inputStore.lastName}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faUserTag} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.lastName ? (
                            <div className="inputErr">
                              {errorStore.lastName}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="position">Position</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="position"
                              id="position"
                              placeholder="Position Held"
                              value={inputStore.position}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faUserMd} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.position ? (
                            <div className="inputErr">
                              {errorStore.position}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">&nbsp;</div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="email">Email Address</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="email"
                              id="email"
                              placeholder="Email Address"
                              value={inputStore.email}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faAt} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.email ? (
                            <div className="inputErr">{errorStore.email}</div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="phone">
                            Landline / Mobile Number{" "}
                          </label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="text"
                              name="phone"
                              id="phone"
                              placeholder="Landline / Mobile Number"
                              value={inputStore.phone}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faPhone} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.phone ? (
                            <div className="inputErr">{errorStore.phone}</div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="password">Password</label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="password"
                              name="password"
                              id="password"
                              placeholder="Password"
                              value={inputStore.password}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faUserLock} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.password ? (
                            <div className="inputErr">
                              {errorStore.password}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div class="col">
                        <div className="form-group pt-3">
                          <label htmlFor="passwordConfirm">
                            Password Confirmation
                          </label>
                          <div className="input-group mb-3">
                            <input
                              className="form-control form-control-lg"
                              type="password"
                              name="passwordConfirm"
                              id="passwordConfirm"
                              placeholder="Password Confirmation"
                              value={inputStore.passwordConfirm}
                              onChange={inputhandler}
                            />
                            <div className="input-group-append">
                              <span
                                className="input-group-text uname_icon"
                                id="basic-addon2"
                              >
                                <i>
                                  <FontAwesomeIcon icon={faUserLock} />
                                </i>
                              </span>
                            </div>
                          </div>
                          {errorStore.passwordConfirm ? (
                            <div className="inputErr">
                              {errorStore.passwordConfirm}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container-md boxc mb-3">
                    <div>
                      <label htmlFor="passwordConfirm">
                        Tell Customer Agreement
                      </label>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          name="termsConfirm"
                          id="termsConfirm"
                          value={inputStore.website}
                          onChange={checkhandler}
                          className="mr-3"
                        />
                        <p class="form-check-label" for="inlineCheckbox1">
                          Please click here to indicate that you have read,
                          understood and agree to our terms & conditions -{" "}
                          <a
                            target="blank"
                            href="/docs/conditions/"
                            className="termsTextLink"
                          >
                            Tell Money Limited Terms & Conditions
                          </a>
                        </p>
                      </div>
                      {termsAcceptedErr ? (
                        <div className="inputErr mt-2">{termsAcceptedErr}</div>
                      ) : null}
                    </div>
                    <div className="text-right mt-4">
                      <button
                        className="default-btn default-btn-theme-2"
                        id="login_button"
                        type="submit"
                      >
                        <div>
                          Register
                         <i className="sbmt_but_icon">
                          {isLoading === 0 ? (
                            <FontAwesomeIcon icon={faKey} />
                          ) : (
                            <FontAwesomeIcon icon={faSpinner} spin />
                          )}
                        </i>
                        </div>
                        <span></span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : null}
            {registerStage === 1 ? (
              <Fade>
                <div id="s2_form">
                  {showError === 2 ? (
                    <Message
                      infoType={authMessageType}
                      infoTitle={authMessageTitle}
                      infoDesc={authMessageDesc}
                    />
                  ) : null}
                  <form>
                    <div className="sign-in-mfa-setup">
                      <h3 className="text-center">
                        Set-Up Multifactor Authentication
                      </h3>
                      <p className="text-center">
                        Multi-factor authentication is required for your client
                        login. Please scan the QRCode below or enter the
                        reference below in your prefered authenticator App to
                        enable on your login.{" "}
                      </p>
                      <div className="text-center"></div>
                      <div className="text-center ">
                        Manual Entry Code : <strong></strong>
                      </div>

                      <p className="text-center">
                        Once complete please enter the 6 digit code generated to
                        verify and complete the set-up.
                      </p>
                      <div className="form-group">
                        <div className="input-group mb-3">
                          <input
                            className="form-control form-control-lg"
                            type="number"
                            name="totp_code"
                            id="totp_code"
                            placeholder="Enter Verification Code"
                          />
                          <div className="input-group-append">
                            <span
                              className="input-group-text totp_icon"
                              id="basic-addon2"
                            >
                              <i>
                                <FontAwesomeIcon icon={faQrcode} />
                              </i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="sign-btn text-center">
                        <div className="form-group">
                          <button
                            className="default-btn default-btn-theme-2"
                            id="login_button"
                            type="button"
                          >
                            <div>
                              Verify
                              <i className="sbmt_but_icon">
                                <FontAwesomeIcon icon={faFingerprint} />
                              </i>
                            </div>
                            <span></span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </Fade>
            ) : null}
            {registerStage === 3 ? (
              <Fade>
                <div id="login_success">
                  <form>
                    <div className="sign-in-mfa-setup">
                      <h3 className="text-center">Complete</h3>
                      <p className="text-center">
                        You have registered successfully
                      </p>

                      <div className="text-center">
                        <svg
                          className="checkmark"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 52 52"
                        >
                          <circle
                            className="checkmark__circle"
                            cx="26"
                            cy="26"
                            r="25"
                            fill="none"
                          />
                          <path
                            className="checkmark__check"
                            fill="none"
                            d="M14.1 27.2l7.1 7.2 16.7-16.8"
                          />
                        </svg>
                      </div>
                      <p className="text-center">
                        Please follow the instructions in your email.
                      </p>
                    </div>
                  </form>
                </div>
              </Fade>
            ) : null}
          </div>

          <p className="text-center">
            Already have an account? <a href="/login/">Sign In.</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default RegisterPage;
